/* eslint-disable */
import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("offerai_token"));
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    if (!localStorage.getItem("offerai_token")) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch (e) {
      localStorage.removeItem("offerai_token");
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("offerai_token", r.data.access_token);
    setToken(r.data.access_token);
    setUser(r.data.user);
  };
  const register = async (email, password, full_name) => {
    const r = await api.post("/auth/register", { email, password, full_name });
    localStorage.setItem("offerai_token", r.data.access_token);
    setToken(r.data.access_token);
    setUser(r.data.user);
  };
  const logout = () => {
    localStorage.removeItem("offerai_token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, token, login, register, logout, refresh, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
